(function() {
  // Function to sync active thumbnail with gallery scroll
  function syncThumbnailOnScroll() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery) return;

    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    
    if (!mainSlides || !thumbSlides) return;

    let scrollTimeout;
    let rafId = null;
    let lastActiveIndex = null;
    let isUpdating = false;
    let isInitializing = true;
    let initialSetupComplete = false;
    
    // Helper function to handle video visibility and autoplay
    // Note: Browser autoplay policies may prevent autoplay in some cases:
    // - Videos must be muted (mute=1) for autoplay to work in most browsers
    // - Some browsers require user interaction before autoplay is allowed
    // - Mobile browsers have stricter autoplay policies
    function handleVideoSlide(videoSlide) {
      if (!videoSlide || videoSlide.dataset.originIndex !== 'video') return;
      
      requestAnimationFrame(() => {
        const videoId = gallery.dataset.videoId;
        if (!videoId) return;
        
        const videoContainer = videoSlide.querySelector('.w-full.relative') || videoSlide.firstElementChild;
        if (!videoContainer) return;
        
        // Find and hide the thumbnail wrapper
        const thumbnailWrapper = videoContainer.querySelector('div.block');
        if (thumbnailWrapper) {
          thumbnailWrapper.style.setProperty('display', 'none', 'important');
          thumbnailWrapper.style.setProperty('opacity', '0', 'important');
          thumbnailWrapper.style.setProperty('visibility', 'hidden', 'important');
          thumbnailWrapper.style.setProperty('pointer-events', 'none', 'important');
          thumbnailWrapper.style.setProperty('position', 'absolute', 'important');
          thumbnailWrapper.style.setProperty('z-index', '-1', 'important');
        }
        
        const thumbnailImg = videoContainer.querySelector('img');
        if (thumbnailImg) {
          thumbnailImg.style.setProperty('display', 'none', 'important');
          thumbnailImg.style.setProperty('opacity', '0', 'important');
          thumbnailImg.style.setProperty('visibility', 'hidden', 'important');
          thumbnailImg.style.setProperty('z-index', '-1', 'important');
        }
        
        // Build the YouTube URL with all required parameters for autoplay
        const autoplayUrl = `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&loop=1&rel=0&iv_load_policy=3&modestbranding=1&controls=1&showinfo=0&mute=1&autoplay=1&enablejsapi=1`;
        
        let videoFrame = videoSlide.querySelector('#gallery_video');
        
        if (videoFrame) {
          // Aggressively remove ALL possible visibility-hiding classes
          const classesToRemove = ['opacity-0', 'invisible', 'hidden', 'opacity-0!', 'invisible!', 'hidden!', '!opacity-0', '!invisible', '!hidden'];
          classesToRemove.forEach(cls => {
            videoFrame.classList.remove(cls);
          });
          
          // Add visibility classes
          videoFrame.classList.add('opacity-100', 'visible', 'block');
          
          // Set ALL inline styles with !important to ensure visibility and override any CSS
          videoFrame.style.setProperty('opacity', '1', 'important');
          videoFrame.style.setProperty('visibility', 'visible', 'important');
          videoFrame.style.setProperty('display', 'block', 'important');
          videoFrame.style.setProperty('z-index', '10', 'important');
          videoFrame.style.setProperty('position', 'absolute', 'important');
          videoFrame.style.setProperty('top', '0', 'important');
          videoFrame.style.setProperty('left', '0', 'important');
          videoFrame.style.setProperty('right', '0', 'important');
          videoFrame.style.setProperty('bottom', '0', 'important');
          videoFrame.style.setProperty('width', '100%', 'important');
          videoFrame.style.setProperty('height', '100%', 'important');
          videoFrame.style.setProperty('pointer-events', 'auto', 'important');
          videoFrame.style.setProperty('transform', 'none', 'important');
          videoFrame.style.setProperty('clip', 'auto', 'important');
          videoFrame.style.setProperty('clip-path', 'none', 'important');
          
          // Force a reflow to ensure styles are applied
          void videoFrame.offsetHeight;
          
          // Recreate iframe to ensure autoplay works (changing src doesn't always trigger autoplay)
          // Check if we need to reload for autoplay
          if (!videoFrame.src.includes('autoplay=1') || videoFrame.src !== autoplayUrl) {
            // Remove old iframe
            const parent = videoFrame.parentNode;
            videoFrame.remove();
            
            // Create new iframe with autoplay
            videoFrame = document.createElement('iframe');
            videoFrame.id = 'gallery_video';
            videoFrame.className = 'absolute inset-0 opacity-100 visible block';
            videoFrame.src = autoplayUrl;
            videoFrame.width = '100%';
            videoFrame.height = '100%';
            videoFrame.frameBorder = '0';
            videoFrame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
            videoFrame.setAttribute('allowfullscreen', '');
            
            // Set ALL inline styles with !important
            videoFrame.style.setProperty('opacity', '1', 'important');
            videoFrame.style.setProperty('visibility', 'visible', 'important');
            videoFrame.style.setProperty('display', 'block', 'important');
            videoFrame.style.setProperty('z-index', '10', 'important');
            videoFrame.style.setProperty('position', 'absolute', 'important');
            videoFrame.style.setProperty('top', '0', 'important');
            videoFrame.style.setProperty('left', '0', 'important');
            videoFrame.style.setProperty('right', '0', 'important');
            videoFrame.style.setProperty('bottom', '0', 'important');
            videoFrame.style.setProperty('width', '100%', 'important');
            videoFrame.style.setProperty('height', '100%', 'important');
            videoFrame.style.setProperty('pointer-events', 'auto', 'important');
            videoFrame.style.setProperty('transform', 'none', 'important');
            videoFrame.style.setProperty('clip', 'auto', 'important');
            videoFrame.style.setProperty('clip-path', 'none', 'important');
            
            // Append new iframe
            videoContainer.appendChild(videoFrame);
          }
        } else {
          // If iframe doesn't exist, create it with autoplay
          const videoIframe = document.createElement('iframe');
          videoIframe.id = 'gallery_video';
          videoIframe.className = 'absolute inset-0 opacity-100 visible block';
          videoIframe.src = autoplayUrl;
          videoIframe.width = '100%';
          videoIframe.height = '100%';
          videoIframe.frameBorder = '0';
          videoIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
          videoIframe.setAttribute('allowfullscreen', '');
          
          // Set ALL inline styles with !important
          videoIframe.style.setProperty('opacity', '1', 'important');
          videoIframe.style.setProperty('visibility', 'visible', 'important');
          videoIframe.style.setProperty('display', 'block', 'important');
          videoIframe.style.setProperty('z-index', '10', 'important');
          videoIframe.style.setProperty('position', 'absolute', 'important');
          videoIframe.style.setProperty('top', '0', 'important');
          videoIframe.style.setProperty('left', '0', 'important');
          videoIframe.style.setProperty('right', '0', 'important');
          videoIframe.style.setProperty('bottom', '0', 'important');
          videoIframe.style.setProperty('width', '100%', 'important');
          videoIframe.style.setProperty('height', '100%', 'important');
          videoIframe.style.setProperty('pointer-events', 'auto', 'important');
          videoIframe.style.setProperty('transform', 'none', 'important');
          videoIframe.style.setProperty('clip', 'auto', 'important');
          videoIframe.style.setProperty('clip-path', 'none', 'important');
          
          videoContainer.appendChild(videoIframe);
        }
      });
    }
    
    function updateActiveThumbnail(skipChangeCheck = false) {
      // Prevent concurrent updates
      if (isUpdating) return;
      
      const slides = Array.from(mainSlides.children).filter(slide => slide.dataset.originIndex);
      if (slides.length === 0) return;
      
      const containerRect = mainSlides.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;
      
      // Find the slide that is most visible or closest to center
      let activeSlide = null;
      let bestScore = -1;
      const minVisibilityRatio = 0.5;
      
      slides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - containerCenter);
        
        // Check if the slide is significantly visible
        const visibleWidth = Math.min(slideRect.right, containerRect.right) - Math.max(slideRect.left, containerRect.left);
        const visibilityRatio = visibleWidth / slideRect.width;
        
        // Calculate a score: higher visibility and closer to center = better
        if (visibilityRatio >= minVisibilityRatio) {
          const score = visibilityRatio * 0.4 + (1 - Math.min(distance / containerRect.width, 1)) * 0.6;
          
          if (score > bestScore) {
            bestScore = score;
            activeSlide = slide;
          }
        }
      });
      
      // If no slide meets visibility threshold, find the one closest to the center
      if (!activeSlide && slides.length > 0) {
        let minDistance = Infinity;
        slides.forEach((slide) => {
          const slideRect = slide.getBoundingClientRect();
          const slideCenter = slideRect.left + slideRect.width / 2;
          const distance = Math.abs(slideCenter - containerCenter);
          
          if (distance < minDistance) {
            minDistance = distance;
            activeSlide = slide;
          }
        });
      }
      
      if (activeSlide) {
        const originIndex = activeSlide.dataset.originIndex;
        if (!originIndex) return;
        
        // Only update if the active slide has actually changed (unless during initial setup)
        if (!skipChangeCheck && lastActiveIndex === originIndex) {
          return;
        }
        
        isUpdating = true;
        lastActiveIndex = originIndex;
        
        // Use requestAnimationFrame for smooth updates
        if (rafId) {
          cancelAnimationFrame(rafId);
        }
        
        rafId = requestAnimationFrame(() => {
          // Remove active class from all slides and thumbnails
          Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
          Array.from(thumbSlides.children).forEach(thumb => thumb.classList.remove('active'));
          
          // Add active class to the current slide and corresponding thumbnail
          activeSlide.classList.add('active');
          const correspondingThumb = thumbSlides.querySelector(`[data-origin-index="${originIndex}"]`);
          if (correspondingThumb) {
            correspondingThumb.classList.add('active');
          }
          
          // Handle video slide visibility and autoplay
          if (originIndex === 'video') {
            handleVideoSlide(activeSlide);
          }
          
          // Update model info if available
          const modelInfo = activeSlide.dataset.modelInfo;
          const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
          if (modelInfoElement) {
            modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
          }
          
          isUpdating = false;
          rafId = null;
        });
      }
    }
    
    // Use IntersectionObserver for better performance (works on both mobile and desktop)
    if ('IntersectionObserver' in window) {
      const observerOptions = {
        root: mainSlides,
        rootMargin: '0px',
        threshold: [0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
      };
      
      let observer;
      let intersectionTimeout;
      let lastIntersectionIndex = null;
      
      const handleIntersection = (entries) => {
        // Ignore intersection events during initial setup to prevent glitching
        if (isInitializing) {
          return;
        }
        
        // Debounce intersection updates to prevent glitches
        clearTimeout(intersectionTimeout);
        
        intersectionTimeout = setTimeout(() => {
          // Find the entry with the highest intersection ratio
          let maxRatio = 0;
          let mostVisibleEntry = null;
          
          entries.forEach(entry => {
            if (entry.intersectionRatio > maxRatio) {
              maxRatio = entry.intersectionRatio;
              mostVisibleEntry = entry;
            }
          });
          
          // Use a consistent threshold
          const minThreshold = 0.5;
          
          if (mostVisibleEntry && mostVisibleEntry.intersectionRatio >= minThreshold) {
            const activeSlide = mostVisibleEntry.target;
            const originIndex = activeSlide.dataset.originIndex;
            
            if (!originIndex) return;
            
            // Only update if the active slide has actually changed
            if (lastIntersectionIndex === originIndex) {
              return;
            }
            
            lastIntersectionIndex = originIndex;
            
            // Use requestAnimationFrame for smooth updates
            requestAnimationFrame(() => {
              // Remove active class from all slides and thumbnails
              Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
              Array.from(thumbSlides.children).forEach(thumb => thumb.classList.remove('active'));
              
              // Add active class to the current slide and corresponding thumbnail
              activeSlide.classList.add('active');
              const correspondingThumb = thumbSlides.querySelector(`[data-origin-index="${originIndex}"]`);
              if (correspondingThumb) {
                correspondingThumb.classList.add('active');
              }
              
              // Handle video slide visibility and autoplay
              if (originIndex === 'video') {
                handleVideoSlide(activeSlide);
              }
              
              // Update model info if available
              const modelInfo = activeSlide.dataset.modelInfo;
              const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
              if (modelInfoElement) {
                modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
              }
            });
          }
        }, 100); // Consistent debounce for all devices
      };
      
      observer = new IntersectionObserver(handleIntersection, observerOptions);
      
      // Observe all slides
      const observeSlides = () => {
        Array.from(mainSlides.children).forEach(slide => {
          if (slide.dataset.originIndex) {
            observer.observe(slide);
          }
        });
      };
      
      // Set initial active state first, then enable observer
      // Wait for layout to settle before setting initial state
      setTimeout(() => {
        // Force a layout recalculation before determining active slide
        void mainSlides.offsetHeight;
        
        // Set initial active state (skip change check to force initial setup)
        updateActiveThumbnail(true);
        
        // Wait a bit more before enabling observer to prevent initial glitches
        setTimeout(() => {
          // Re-check active thumbnail after observer is about to be enabled
          // This ensures we catch any layout changes that happened during initialization
          updateActiveThumbnail(true);
          
          isInitializing = false;
          initialSetupComplete = true;
          observeSlides();
        }, 300);
      }, 300);
      
      // Re-observe when slides are added/removed (for dynamic content)
      const mutationObserver = new MutationObserver(() => {
        observer.disconnect();
        lastIntersectionIndex = null; // Reset when slides change
        isInitializing = true; // Prevent glitches during rebuild
        initialSetupComplete = false;
        
        // Re-setup after slides change
        setTimeout(() => {
          updateActiveThumbnail(true);
          setTimeout(() => {
            isInitializing = false;
            initialSetupComplete = true;
            observeSlides();
          }, 300);
        }, 100);
      });
      
      mutationObserver.observe(mainSlides, { childList: true });
    } else {
      // Fallback to scroll event for browsers without IntersectionObserver
      // Set initial state first
      setTimeout(() => {
        updateActiveThumbnail(true);
        isInitializing = false;
        initialSetupComplete = true;
      }, 300);
      
      mainSlides.addEventListener('scroll', function() {
        if (isInitializing) return;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveThumbnail, 100);
      }, { passive: true });
    }
    
    // Add thumbnail click handlers to scroll to corresponding slide
    function bindThumbnailClicks() {
      Array.from(thumbSlides.children).forEach(thumb => {
        // Check if already has our listener
        if (thumb.dataset.hasScrollListener === 'true') return;
        
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const originIndex = thumb.dataset.originIndex;
          if (!originIndex) return;
          
          // Ensure video slide exists if clicking video thumbnail
          if (originIndex === 'video') {
            ensureVideoSlide();
          }
          
          const targetSlide = mainSlides.querySelector(`[data-origin-index="${originIndex}"]`);
          if (!targetSlide) return;
          
          // Temporarily disable IntersectionObserver to prevent conflicts
          const wasInitializing = isInitializing;
          isInitializing = true;
          
          // Update active states immediately
          Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
          Array.from(thumbSlides.children).forEach(thumbEl => thumbEl.classList.remove('active'));
          
          targetSlide.classList.add('active');
          thumb.classList.add('active');
          
          // Update model info if available
          const modelInfo = targetSlide.dataset.modelInfo;
          const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
          if (modelInfoElement) {
            modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
          }
          
          // Update last active index
          lastActiveIndex = originIndex;
          
          // Handle YouTube video - show iframe before scrolling
          if (originIndex === 'video') {
            handleVideoSlide(targetSlide);
          }
          
          // Scroll to the target slide after updating visibility
          targetSlide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          
          // Re-enable observer after scroll completes
          setTimeout(() => {
            isInitializing = wasInitializing;
          }, 500);
        });
        
        // Mark as having listener
        thumb.dataset.hasScrollListener = 'true';
      });
    }
    
    // Bind thumbnail clicks after initial setup
    setTimeout(() => {
      bindThumbnailClicks();
    }, 600);
    
    // Re-bind when slides are added/removed
    const thumbnailMutationObserver = new MutationObserver(() => {
      bindThumbnailClicks();
    });
    
    thumbnailMutationObserver.observe(thumbSlides, { childList: true });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncThumbnailOnScroll);
  } else {
    syncThumbnailOnScroll();
  }
  
  // Function to recreate YouTube video slide if missing
  function ensureVideoSlide() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery || !gallery.dataset.videoId) return;
    
    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    if (!mainSlides || !thumbSlides) return;
    
    const videoId = gallery.dataset.videoId;
    let videoSlide = mainSlides.querySelector('[data-origin-index="video"]');
    
    // If video slide doesn't exist, create it
    if (!videoSlide) {
      videoSlide = document.createElement('div');
      videoSlide.className = 'product-video w-full';
      videoSlide.setAttribute('data-origin-index', 'video');
      
      const videoContainer = document.createElement('div');
      videoContainer.className = 'w-full relative';
      
      const thumbnailWrapper = document.createElement('div');
      thumbnailWrapper.className = 'block pt-[100%] group';
      
      const thumbnailImg = document.createElement('img');
      thumbnailImg.src = `https://img.youtube.com/vi/${videoId}/0.jpg`;
      thumbnailImg.alt = `product video - ${videoId}`;
      thumbnailImg.className = 'absolute w-full h-full top-0 left-0 object-cover -z-1';
      thumbnailImg.loading = 'lazy';
      
      thumbnailWrapper.appendChild(thumbnailImg);
      
      // Create YouTube iframe (matching structure from liquid template)
      const videoIframe = document.createElement('iframe');
      videoIframe.id = 'gallery_video';
      videoIframe.className = 'absolute inset-0 opacity-100 visible block';
      videoIframe.src = `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&loop=1&rel=0&iv_load_policy=3&modestbranding=1&controls=1&showinfo=0&mute=1`;
      videoIframe.width = '100%';
      videoIframe.height = '100%';
      videoIframe.frameBorder = '0';
      videoIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      videoIframe.setAttribute('allowfullscreen', '');
      
      videoContainer.appendChild(thumbnailWrapper);
      videoContainer.appendChild(videoIframe);
      videoSlide.appendChild(videoContainer);
      
      // Append video slide to main slides (at the end)
      mainSlides.appendChild(videoSlide);
      
      // Force reflow to ensure styles are applied
      void videoSlide.offsetHeight;
    } else {
      // If video slide exists, ensure iframe is present
      let videoIframe = videoSlide.querySelector('#gallery_video');
      if (!videoIframe) {
        const videoContainer = videoSlide.querySelector('.w-full.relative') || videoSlide;
        videoIframe = document.createElement('iframe');
        videoIframe.id = 'gallery_video';
        videoIframe.className = 'absolute inset-0 opacity-100 visible block';
        videoIframe.src = `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&loop=1&rel=0&iv_load_policy=3&modestbranding=1&controls=1&showinfo=0&mute=1`;
        videoIframe.width = '100%';
        videoIframe.height = '100%';
        videoIframe.frameBorder = '0';
        videoIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        videoIframe.setAttribute('allowfullscreen', '');
        videoContainer.appendChild(videoIframe);
      }
    }
    
    // Ensure thumbnail exists
    let videoThumb = thumbSlides.querySelector('[data-origin-index="video"]');
    if (!videoThumb) {
      videoThumb = document.createElement('div');
      videoThumb.className = 'thumbnail thumbnail--video relative';
      videoThumb.setAttribute('data-origin-index', 'video');
      thumbSlides.appendChild(videoThumb);
    }
    
    return videoSlide;
  }
  
  // Function to scroll to first slide and reset gallery
  function scrollToFirstSlide() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery) return;
    
    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    
    if (!mainSlides || !thumbSlides) return;
    
    // First, ensure video slide exists
    ensureVideoSlide();
    
    // Wait for slides to be populated
    setTimeout(() => {
      const slides = Array.from(mainSlides.children).filter(slide => slide.dataset.originIndex);
      if (slides.length === 0) return;
      
      const firstSlide = slides[0];
      if (!firstSlide) return;
      
      // Scroll to first slide
      firstSlide.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'start'
      });
      
      // Update active states
      Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
      Array.from(thumbSlides.children).forEach(thumb => thumb.classList.remove('active'));
      
      firstSlide.classList.add('active');
      const firstThumb = thumbSlides.querySelector(`[data-origin-index="${firstSlide.dataset.originIndex}"]`);
      if (firstThumb) {
        firstThumb.classList.add('active');
      }
      
      // Update model info
      const modelInfo = firstSlide.dataset.modelInfo;
      const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
      if (modelInfoElement) {
        modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
      }
    }, 200);
  }
  
  // Listen for variant change events
  let previousVariant = null;
  document.addEventListener('buybox:variantChanged', function(e) {
    const gallery = document.querySelector('[data-pg]');
    if (gallery && gallery.hasAttribute('data-gift-pg')) return; // Gift cards: no gallery rebuild on variant change

    const currentVariant = e.detail && e.detail.data ? e.detail.data : null;
    
    if (currentVariant && previousVariant && currentVariant.options && previousVariant.options) {
      const colorChanged = currentVariant.options[0] !== previousVariant.options[0];
      
      if (colorChanged) {
        // Ensure video slide exists immediately
        ensureVideoSlide();
        // Wait a bit for gallery to rebuild, then scroll to first slide
        setTimeout(() => {
          ensureVideoSlide(); // Check again after rebuild
          scrollToFirstSlide();
        }, 400);
      }
    } else if (currentVariant) {
    }
    if (currentVariant) {
      previousVariant = currentVariant;
    }
  });
  
  // Re-initialize when gallery is rebuilt (for variant changes)
  document.addEventListener('DOMContentLoaded', function() {
    const gallery = document.querySelector('[data-pg]');
    if (gallery) {
      let isRebuilding = false;
      let rebuildTimeout;
      
      const mutationObserver = new MutationObserver(function(mutations) {
        if (gallery.hasAttribute('data-gift-pg')) return; // Gift cards: skip gallery rebuild logic

        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            const mainSlides = gallery.querySelector('[data-pg-main-slides]');
            if (!mainSlides) return;
            
            // Check if video slide was removed
            const videoSlideRemoved = Array.from(mutation.removedNodes).some(node => 
              node.nodeType === 1 && 
              (node.classList.contains('product-video') || 
               node.getAttribute('data-origin-index') === 'video' ||
               node.querySelector && node.querySelector('[data-origin-index="video"]'))
            );
            
            // Check if slides were added (gallery rebuild)
            const hasNewSlides = mutation.addedNodes.length > 0 && Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (node.classList.contains('product-image') || 
              node.classList.contains('product-video') || 
              node.classList.contains('product-custom-video'))
            );
            
            // If video was removed or new slides were added, ensure video exists
            if ((videoSlideRemoved || hasNewSlides) && !isRebuilding) {
              clearTimeout(rebuildTimeout);
              isRebuilding = true;
              
              rebuildTimeout = setTimeout(() => {
                // Ensure video slide exists after rebuild
                ensureVideoSlide();
                
                // Scroll to first slide when gallery rebuilds
                scrollToFirstSlide();
                syncThumbnailOnScroll();
                
                isRebuilding = false;
              }, 300);
            }
          }
        });
      });
      
      mutationObserver.observe(gallery, { childList: true, subtree: true });
      
      // Also periodically check for video slide (as a fallback)
      setInterval(function() {
        const gallery = document.querySelector('[data-pg]');
        if (gallery && gallery.dataset.videoId) {
          const mainSlides = gallery.querySelector('[data-pg-main-slides]');
          if (mainSlides) {
            const videoSlide = mainSlides.querySelector('[data-origin-index="video"]');
            if (!videoSlide) {
              ensureVideoSlide();
            }
          }
        }
      }, 1000);
    }
  });
})();